export const FETCH_RECALL_START = "FETCH_RECALL_START";
export const FETCH_RECALL_SUCCESS = "FETCH_RECALL_SUCCESS";
export const FETCH_RECALL_FAIL = "FETCH_RECALL_FAIL";

export const DOWNLOAD_VIN_START = "DOWNLOAD_VIN_START";
export const DOWNLOAD_VIN_SUCCESS = "DOWNLOAD_VIN_SUCCESS";
export const DOWNLOAD_VIN_FAIL = "DOWNLOAD_VIN_FAIL";

export const SET_PAGE_SIZE = "SET_PAGE_SIZE_RECALL";
export const SET_ACTIVE_STATUS = "SET_ACTIVE_STATUS_RECALL";
export const SET_SEARCH_INPUT = "SET_SEARCH_INPUT_RECALL";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE_RECALL";
